import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-ce-socials',
  templateUrl: './landing-ce-socials.component.html',
  styleUrls: ['./landing-ce-socials.component.scss']
})
export class LandingCeSocialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
